// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__RiskAnalysisPage__boldField{font-weight:700}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/premier-capability-policyjob-react/pages/RiskAnalysis/RiskAnalysisPage.module.scss"],"names":[],"mappings":"AAEA,kCACI,eAAA","sourcesContent":["@import \"~@jutro/theme/assets/sass/helpers\";\n\n.boldField {\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boldField": "app__RiskAnalysisPage__boldField"
};
export default ___CSS_LOADER_EXPORT___;
